export default{
    en:{
        srch:{
            modalTitle:'심사대상자 조회',
            empNo:'교원번호',
            name:'이름',
            orgtxt:'소속',
            position:'직위',
            zfield:'연구분야',
            firstEmplmnDt:'신규임용일자',
            cposEmplmnDt:'현직위임용일자',
            currPaySrcls:'현재연구호봉',
            currPaySrclsDt:'현연구호봉승봉일자',
            stndDtCnwkTerm:'기준일자근무년수',
            firstEmplmnDtC:'최초임용일자',
            cposEmplmnDtC:'현직위임용일자',
            reemplyEndDt:'재임용만료일자',
            currPaySrclsB:'급여호봉1',
            currPaySrclsDtB:'급여호봉1승봉일자',
            currPaySrclsCd:'급여호봉1승봉코드',
            befPaySrcls:'급여호봉2',
            befPaySrclsDt:'급여호봉2승봉일자',
            befPaySrclsCd:'급여호봉2승봉코드',
            prePaySrcls:'급여호봉3',
            prePaySrclsDt:'급여호봉3승봉일자',
            prePaySrclsCd:'급여호봉3승봉코드',
            judgementFr:'심사시작일',
            judgementTo:'심사종료일',
            emplmnGnfdYn:'발령사항유무',
            calcInclsYear:'계산되어야할년수',
            slctnRsltCd:'대상여부',
            remark:'비고',
            select:'Select',
            create:'Create',
            dataDownload:'Download Data',
        },
        info:{
            modalTitle:'심사대상자',
            year:'학년',
            term:'학기',
            judgementType:'심사구분',
            empNo:'사용자ID',
            name:'사용자명',
            orgText:'부서명',
            judgementFrom:'심사시작일',
            judgementTo:'심사종료일',
            standardScoreAll:'기준점수(전체)',
            standardScore:'기준점수(연구)',
            judgementRsltCd:'심사신청',
        }
    },
    ko:{
        srch:{
            modalTitle:'심사대상자 조회',
            empNo:'교원번호',
            name:'이름',
            orgtxt:'소속',
            position:'직위',
            zfield:'연구분야',
            firstEmplmnDt:'신규임용일자',
            cposEmplmnDt:'현직위임용일자',
            currPaySrcls:'현재연구호봉',
            currPaySrclsDt:'현연구호봉승봉일자',
            stndDtCnwkTerm:'기준일자근무년수',
            firstEmplmnDtC:'최초임용일자',
            cposEmplmnDtC:'현직위임용일자',
            reemplyEndDt:'재임용만료일자',
            currPaySrclsB:'급여호봉1',
            currPaySrclsDtB:'급여호봉1승봉일자',
            currPaySrclsCd:'급여호봉1승봉코드',
            befPaySrcls:'급여호봉2',
            befPaySrclsDt:'급여호봉2승봉일자',
            befPaySrclsCd:'급여호봉2승봉코드',
            prePaySrcls:'급여호봉3',
            prePaySrclsDt:'급여호봉3승봉일자',
            prePaySrclsCd:'급여호봉3승봉코드',
            judgementFr:'심사시작일',
            judgementTo:'심사종료일',
            emplmnGnfdYn:'발령사항유무',
            calcInclsYear:'계산되어야할년수',
            slctnRsltCd:'대상여부',
            remark:'비고',
            select:'선정',
            create:'생성',
            dataDownload:'데이터 다운로드',
        },
        info:{
            modalTitle:'심사대상자',
            year:'학년',
            term:'학기',
            judgementType:'심사구분',
            empNo:'사용자ID',
            name:'사용자명',
            orgText:'부서명',
            judgementFrom:'심사시작일',
            judgementTo:'심사종료일',
            standardScoreAll:'기준점수(전체)',
            standardScore:'기준점수(연구)',
            judgementRsltCd:'심사신청',
        }
    }
}